export default __webpack_public_path__ + "static/media/OtherImpLinkLogo.06346459.svg";